import _ProgressBar from "@ramonak/react-progress-bar";
import "./ServerSideExportStatus.scss";
import { COLOR_ERROR, COLOR_NEUTRAL, COLOR_POSITIVE } from "../../../../common/constants/export-constants";

// Vite 8 rolldown does not unwrap CJS __esModule default for @ramonak/react-progress-bar
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ProgressBar = ((_ProgressBar as any).default ?? _ProgressBar) as typeof _ProgressBar;

type Props = {
  progressPercent: number;
  isExporting: boolean;
  isExported: boolean;
  isFailed: boolean;
};

const ServerSideExportStatus = (props: Props) => {
  const { progressPercent = 0, isExporting, isExported, isFailed } = props;

  const minProgressPercent = 55;
  const _progressPercent = isExporting && progressPercent < minProgressPercent ? minProgressPercent : progressPercent;

  const getProgressBarColor = () => {
    if (isExporting || isExported) {
      return COLOR_POSITIVE;
    }
    if (isFailed) {
      return COLOR_ERROR;
    }
    return COLOR_NEUTRAL;
  };
  return (
    <>
      <ProgressBar
        completed={_progressPercent}
        customLabel=" "
        height="0.313rem"
        animateOnRender={true}
        bgColor={getProgressBarColor()}
        borderRadius="0rem"
      />
    </>
  );
};

export default ServerSideExportStatus;
